import styled from 'styled-components'

export const WrapperCard = styled.div`
  padding: 24px;
  min-height: 75vh;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 0px 0px 6px #00000029;
`
